import { ChevronDownIcon, ChevronUpIcon } from '@chakra-ui/icons';
import { Box, Flex, Text, Menu, Image, Avatar, HStack, Button, MenuItem, MenuList, MenuButton, useToast } from '@chakra-ui/react';
import { useRef, useState } from 'react';
// import { useRouter } from 'next/router';
// import { ChevronDown, ChevronUp } from '@masaischool/lotus';
// import { sendTrackingEvent } from '../../utils/gtm';
import { useNavigate } from 'react-router-dom';
import { useOutsideClick } from '@chakra-ui/react';
import { useMutation } from 'react-query';
import { AxiosError } from 'axios';
import { UIErrorResponse } from 'types/src/error';
import { signOut } from '../../../apis/auth';
import { useUser } from '../../../hooks/V2/useUser';
import { SAGEX_ORG_KEY } from '../../../utils/segexOrgName';
import { useDomainConfig } from '../../../hooks/useDomainConfig';

const UserDropdown = ({ profileData, onModalOpen, showName = true }: any) => {
	const menuRef = useRef<any>();
	const navigate = useNavigate();
	const [isMenuOpen, setIsMenuOpen] = useState(false);
	const toast = useToast();

	const { data: domainConfig } = useDomainConfig({ uiHost: window.location.host });
	useOutsideClick({
		// @ts-ignore
		ref: menuRef,
		handler: () => setIsMenuOpen(false),
	});

	// @ts-ignore
	const handleRoute = (route, isExternal) => {
		if (isExternal) {
			window.location.href = route;
		} else {
			navigate(route);
		}
	};

	const { mutate: signOutMutate, isLoading } = useMutation(signOut, {
		onSuccess: () => {
			if (SAGEX_ORG_KEY === domainConfig?.key) {
				window.location.href = 'http://sageextension.com/login';
			} else {
				window.location.reload();
			}
		},
		onError: (error: AxiosError<UIErrorResponse>) => {
			toast({
				title: 'Error',
				description: error?.response?.data?.message || 'User sign out failed',
				status: 'error',
				duration: 2000,
				isClosable: true,
				position: 'top',
			});
		},
	});

	const userDropdownMenus = [
		{
			handleClick: `/profile`,
			isExternal: true,
			name: 'My Profile',
			icon: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/dashboard_b461dfcbf8.svg',
			event: 'website_learn_header_profile_tab',
		},
		{
			handleClick: '/dashboard',
			isExternal: false,
			name: 'My Dashboard',
			icon: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/dashboard_934bc58d9c.png',
			event: 'website_learn_header_bookmarks',
		},
		{
			handleClick: signOutMutate,
			isExternal: false,
			name: 'Sign Out',
			icon: 'https://masai-website-images.s3.ap-south-1.amazonaws.com/signout_5d564c00ff.svg',
			event: 'signOut',
		},
	];
	return (
		<Flex alignItems="center" justify={{ base: 'flex-end', md: 'flex-start' }} ref={menuRef}>
			<Menu closeOnSelect={true} autoSelect={false} isOpen={isMenuOpen} placement="bottom-end" offset={[8, 4]}>
				{({ isOpen }) => (
					<Box>
						<MenuButton
							p="0"
							minW="0px"
							className="userMenuStep"
							border="none"
							as={Button}
							display="flex"
							textStyle="body1-md"
							isActive={isOpen}
							variant="unstyled"
							alignItems="center"
							justifyContent="center"
							textTransform="initial"
							_hover={{ bg: 'none' }}
							_active={{ bg: 'none' }}
							_focus={{ border: 'none', bg: 'none' }}
							onClick={() => {
								// @ts-ignore
								setIsMenuOpen(prev => !prev);
							}}
						>
							<HStack>
								<Avatar
									h={{ base: '24px', md: '24px' }}
									w={{ base: '24px', md: '24px' }}
									size="auto"
									fontWeight="600"
									bg="#D6E2FA"
									color="#3470E4"
									name={profileData.name}
									fontSize={{ base: '14px', md: '14px' }}
									src={profileData?.dp_url}
								/>
								{/* {showName && <Text display={{ base: 'none', md: 'block' }}>{profileData.name.trim().split(' ')[0]}</Text>} */}
								{/* {isOpen ? (
									<Box display={{ base: 'none', md: 'block' }}>
										<ChevronUpIcon color="ms-blue.500" boxSize="4" />
									</Box>
								) : (
									<Box display={{ base: 'none', md: 'block' }}>
										<ChevronDownIcon color="ms-blue.500" boxSize="4" />
									</Box>
								)} */}
							</HStack>
						</MenuButton>

						<MenuList
							zIndex="2"
							className={'user_menu1'}
							minWidth="182px"
							maxHeight="245px"
							p="0px !important"
							overflowX="hidden"
							borderRadius="16px"
							overscrollX={'-moz-initial'}
							boxShadow="0px -2px 11px -2px rgba(0, 0, 0, 0.1), 0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)"
							css={{
								'::-webkit-scrollbar': {
									width: '8px',
								},

								'::-webkit-scrollbar-thumb': {
									background: '#D9D9D9',
									borderRadius: '10px',
								},
							}}
						>
							{userDropdownMenus &&
								userDropdownMenus.map((menu, index) => (
									<MenuItem
										key={index}
										h="48px"
										p="12px 16px"
										closeOnSelect
										fontSize="16px"
										fontWeight="500"
										color="#0A0103"
										fontFamily="Open Sans"
										justifyContent="space-between"
										_hover={{
											color: 'ms-blue.500',
											bgColor: 'ms-blue.50',
											boxShadow: '0px 1px 0px #D9D9D9',
										}}
										onClick={() => {
											// sendTrackingEvent({
											// 	event: menu.event,
											// 	eventLabel: router.asPath,
											// });
											// @ts-ignore
											typeof menu.handleClick === 'string' ? handleRoute(menu.handleClick, menu?.isExternal) : menu?.handleClick();
											// @ts-ignore
											setIsMenuOpen(prev => !prev);
										}}
										borderTop={index > 0 ? '1px solid #D9D9D9' : 'none'}
										icon={<Image maxW="24px" src={menu.icon} alt={menu.name} />}
									>
										{menu.name}
									</MenuItem>
								))}
						</MenuList>
					</Box>
				)}
			</Menu>
		</Flex>
	);
};

export default UserDropdown;
